import { FlagValue } from '@openfeature/core';
import { useFlag as useOpenFeatureFlag } from '@openfeature/react-sdk';

import type { FlagValueResolver } from '@spotify/confidence-core-react';

export const useOpenFeatureFlagValue: FlagValueResolver = (
  flag,
  defaultValue,
) =>
  useOpenFeatureFlag(flag, defaultValue as FlagValue)
    .value as typeof defaultValue;
